import { Action } from '@ngrx/store';

export class ReduxAction<T> implements Action {
    readonly type: string;

    constructor(public readonly payload?: T) {}
}
